import type { ScheduleEvent, ScheduleRepeat } from '../types/schedule'
import * as rrule from 'rrule'

export function modifyScheduleFormData(
  event: FormDataEvent,
  eventType: ScheduleEvent,
  allDay: boolean,
) {
  if (eventType === 'OPENING_HOUR') {
    modifyFormDataOpeningHour(event, allDay)
  }
}

function modifyFormDataOpeningHour(event: FormDataEvent, allDay: boolean) {
  const { RRule } = rrule
  const startDate = event.formData.get('start_date') as string | null
  const endDate = event.formData.get('end_date') as string | null
  const repeat = event.formData.get('repeat') as ScheduleRepeat | null

  if (startDate !== null && repeat !== null) {
    const rule = new RRule({
      freq: repeat === 'NO_REPEAT' ? RRule.WEEKLY : RRule[repeat],
      interval: 1,
      byweekday:
        repeat === 'WEEKLY' ? [new Date(startDate).getDay() - 1] : undefined,
      dtstart: new Date(startDate),
      until: endDate ? new Date(endDate) : undefined,
      count: repeat === 'NO_REPEAT' ? 1 : undefined,
    })

    event.formData.append('recurring_rule', rule.toString())

    if (allDay) {
      event.formData.set('start_hour', '00:00')
      event.formData.set('end_hour', '24:00')
    }
  }
}
